const mixinPartial = {
  data() {
    return {
      url: "",
      urlRelatorio: "",
      argumentos: {}
    };
  },

  methods: {
    CriarUrl(args, opcoes) {
      this.argumentos = args;

      return this.ConfigurarUrl(opcoes).ConfigurarOptions();
    },

    CriarFormData(dados) {
      let formData = new FormData();

      for (const key in dados) {
        formData.append(key, dados[key]);
      }

      return formData;
    },

    ConfigurarUrl({
      adicionarApi = true,
      adicionarAuth = false,
      apiRelatorio = false
    } = {}) {
      this.url = `${this.$appConfig.config.API}`;
      this.urlRelatorio = `${this.$appConfig.config.API_RELATORIOS}`;

      this.url = apiRelatorio ? this.urlRelatorio : this.url;

      if (this.url.charAt(this.url.length - 1) !== "/") {
        this.url += "/";
      }

      if (adicionarAuth) {
        this.url += "auth/";
      } else if (adicionarApi) {
        this.url += "api/";
      }

      if (this.argumentos.resource.charAt(0) === "/") {
        this.argumentos.resource = this.argumentos.resource.substring(1);
      }

      this.url += this.argumentos.resource;

      return this;
    },

    ConfigurarOptions() {
      var params = "";

      for (const key in this.argumentos.params) {
        if (key in this.argumentos.params) {
          const item = this.argumentos.params[key];

          if (!["", null, undefined].includes(item)) {
            params += "&" + key + "=" + item;
          }
        }
      }

      if (params != "") {
        if (params.charAt(0) === "&") {
          params = params.substring(1);
        }

        if (this.url.indexOf("?") === -1) {
          this.url += "?";
        }

        this.url += params;
      }

      return this.url;
    }
  }
};

export default mixinPartial;
